import { Logger } from '@eurotunnel-pax/leshuttle.ui/src/scripts/utilities/Logger'
import { loadSprites } from '@eurotunnel-pax/leshuttle.ui/src/scripts/utilities/SVGLoader'
import { loadOffcanvas } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/patterns/offCanvas'
import { setupAccordions } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/patterns/accordion'
import { loadFlyoutDelegates } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/controls/flyoutDelegates'
import { setupBookingBar } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/controls/bookingBar'
import { loadDialogOpeners } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/patterns/showDialog'
import { loadAccordionClosers } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/controls/accordionClose'
import { setupCountdownTimers } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/controls/countdownTimer'
import { setupCopyToClipboard } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/controls/copy-to-clipboard'
import { setupFlipCards } from '@eurotunnel-pax/leshuttle.ui/stories/Molecules/Cards/Flip/flip-card'
import { loadDialogs } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/controls/dialog'
import { setupModals } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/controls/modal'
import { setupSelectStyling } from '@eurotunnel-pax/leshuttle.ui/src/scripts/forms/inputs/SelectFormatting'
import { setupDatePickers, setupDatePickersWithRange } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/controls/datePicker'
import { setupTabs } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/tabs'
import { setupInlineVideos } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/video/inline-video'
import { setupSliderCardSets } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/molecules/slider-card-set'
import { setupArticleMedias } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/video/article-media'
import { setupSearch } from './components/Search'
import { setupCountryModal } from './components/CountryModal'
import { setupSiteAlerts } from './components/SiteAlerts'
import { setupLazyLoaders } from '@eurotunnel-pax/leshuttle.ui/src/scripts/utilities/LazyLoad'
import { setupMatchHeight } from '@eurotunnel-pax/leshuttle.ui/src/scripts/utilities/match-height'
import { setupSupportLists } from '@eurotunnel-pax/leshuttle.ui/stories/Molecules/TextBlocks/SupportListTextBlock/support-list'
import { setupArticleListing } from './components/ArticleListing'
import { setupImageZoom } from '@eurotunnel-pax/leshuttle.ui/stories/Components/ImageZoom/image-zoom'
import { setupListPaging } from './components/ListPaging'
import { setupDynamicVideoButtons, setupMoodVideos } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/video/media-block'
import './forms/updateableFormHelper-crafted'
import './forms/file-uploader'
import { setupWebForms } from './forms'
import valRecaptcha from './forms/rules/recaptcha.js'
import { handleCmsWidgetLoading } from './utilities/CmsWidgetLoader.js'
import { setupBookingBarSubmit, processBookingFormFromQuery } from './components/BookingBar.js'
import { handleNewsletterFormSubmit } from './components/NewsletterForm.js'
import { setupLoadingButtons } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/patterns/loading-button'
import { loadSections } from './components/layout/LoadSections'
import { setupScrolling } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/controls/drag-scroll'
import { detectMac } from '@eurotunnel-pax/leshuttle.ui/src/scripts/utilities/MacDetection'
import { setupTracking } from './tracking/setup-tracking'
import { setupLiveChatTriggers } from './utilities/LiveChat.js'
import { setupOneTrustManagePreferences } from './utilities/OneTrust.js'

const logger = new Logger('Application')

logger.log('Loading Sprite sheet.')

loadSprites()
loadOffcanvas()
setupAccordions(document)
loadFlyoutDelegates()
setupLoadingButtons()
loadDialogOpeners()
loadAccordionClosers()
setupCountdownTimers(document)
setupBookingBar(document)
setupCopyToClipboard(document)
setupFlipCards(document)
setupAccordions(document)
loadDialogs(document)
setupSelectStyling(document)
setupModals(document)
setupDatePickersWithRange(document)
setupDatePickers(document)
setupTabs(document)
setupInlineVideos(document)
setupSliderCardSets(document)
setupArticleMedias(document)
setupCountryModal()
setupSiteAlerts()
setupLazyLoaders(document)
setupSupportLists(document)
setupArticleListing()
setupImageZoom(document)
setupMoodVideos(document)
setupDynamicVideoButtons(document)
setupScrolling(document)
setupMatchHeight(document)
detectMac()
setupListPaging()
valRecaptcha()
setupWebForms()
handleCmsWidgetLoading()
setupBookingBarSubmit()
processBookingFormFromQuery()
handleNewsletterFormSubmit()
setupLiveChatTriggers()
setupOneTrustManagePreferences()
window.setTimeout(() => {
  setupSearch()
}, 1000)
loadSections(document)
setupTracking()

if (navigator.userAgent.indexOf('Firefox') !== -1) {
  const elem = document.querySelector('body')
  elem.classList.add('body--firefox')
}
